import { useEffect, useState, useCallback } from "react"
import useErroPadrao from '../../../hooks/useErroPadrao';
import useHelp from '../../../hooks/useHelp';
import { useNavigate, Link } from "react-router-dom";
import { CHAVE_TOKEN, real, dataBR, hojeISO, linkWhatsApp } from "../../../utils/formata";
import { Vazio, EsqueletoLista } from "../../Components/Estado";

export default function RecebimentoConsulta() {
    const [parcelas, setParcelas] = useState([]);
    const [filtro, setFiltro] = useState("todas");
    const [carregando, setCarregando] = useState(true);
    const [recebendo, setRecebendo] = useState(null);
    const [pagamento, setPagamento] = useState({});
    const [salvandoBaixa, setSalvandoBaixa] = useState(false);
    const { consultarParcelasAbertas, pagarParcela } = useHelp();
    const { setErroPadrao } = useErroPadrao();
    const navigate = useNavigate();
    const hoje = hojeISO();

    const carregar = useCallback(() => {
        setCarregando(true);
        const ate = filtro === "7dias" ? new Date(Date.now() + 7 * 86400000).toISOString().slice(0, 10) : undefined;
        consultarParcelasAbertas(filtro === "atrasadas" ? "atrasadas" : undefined, ate)
            .then((data) => setParcelas(data || []))
            .catch((error) => setErroPadrao(error))
            .finally(() => setCarregando(false));
    }, [filtro, consultarParcelasAbertas, setErroPadrao]);

    useEffect(() => {
        if (!localStorage.getItem(CHAVE_TOKEN)) {
            navigate("/login");
            return;
        }
        carregar();
    }, [carregar, navigate]);

    function fecharRecebimento() {
        setRecebendo(null);
        setPagamento({});
    }

    function handleReceber(manterSaldo = false) {
        setSalvandoBaixa(true);
        pagarParcela(recebendo.id, { ...pagamento, manterSaldo: manterSaldo === true })
            .then(() => { fecharRecebimento(); carregar(); })
            .catch((error) => setErroPadrao(error))
            .finally(() => setSalvandoBaixa(false));
    }

    function handleSubmitReceber(e) {
        e.preventDefault();
        handleReceber(false);
    }

    function mensagemCobranca(p) {
        const empresa = p.Emprestimo?.Empresa || {};
        const atrasada = p.dataVencimento < hoje;
        return atrasada
            ? `Olá ${empresa.responsavel || ""}! Aqui é da Help Empresarial. A parcela ${p.numero} do contrato #${p.EmprestimoId}, no valor de ${real(p.valor)}, venceu em ${dataBR(p.dataVencimento)}. Podemos acertar o pagamento? 🤝`
            : `Olá ${empresa.responsavel || ""}! Aqui é da Help Empresarial. Lembrando que a parcela ${p.numero} do contrato #${p.EmprestimoId}, no valor de ${real(p.valor)}, vence em ${dataBR(p.dataVencimento)}. Qualquer dúvida estou à disposição! 😊`;
    }

    const totalAberto = parcelas.reduce((s, p) => s + Number(p.valor), 0);
    const atrasadas = parcelas.filter((p) => p.dataVencimento < hoje).length;

    return (
        <div className="pagina">
            <div className="cabecalho-pagina">
                <h2 className="he-titulo">Recebimentos <span className="he-dourado">& Cobrança</span></h2>
                <div className="resumo-hero resumo-topo">
                    <div>
                        <div className="resumo-rotulo">Total em aberto</div>
                        <div className="resumo-valor">{real(totalAberto)}</div>
                    </div>
                    <div className="resumo-apoio">
                        {carregando ? "atualizando..." : `${parcelas.length} parcela${parcelas.length === 1 ? "" : "s"} · ${atrasadas} em atraso`}
                    </div>
                </div>
            </div>

            <div className="filtros-status" style={{margin: "1em 0"}}>
                {[["todas", "Todas em aberto", "bi bi-list-ul"], ["atrasadas", "Atrasadas", "bi bi-exclamation-circle-fill"], ["7dias", "Próximos 7 dias", "bi bi-calendar-week"]].map(([k, v, icone]) => (
                    <button key={k} className={`btn btn-sm ${filtro === k ? "btn-he" : "btn-outline-he"}`} onClick={() => setFiltro(k)}>
                        <i className={icone} style={{marginRight: 6}}></i>{v}
                    </button>
                ))}
            </div>

            {carregando ? <EsqueletoLista quantidade={4}/> :
            <div className={`he-card sem-rolagem ${recebendo ? "sem-vidro" : ""}`}>
                {/* Confirmação vem por cima, no meio da tela: antes o formulário nascia
                    no topo da lista e era preciso rolar pra achar depois de tocar em Receber */}
                {recebendo &&
                    <div className="modal-fundo" onClick={(e) => { if (e.target === e.currentTarget) fecharRecebimento(); }}>
                        <form onSubmit={handleSubmitReceber} className="modal-caixa form-mobile">
                            <div className="modal-cabecalho">
                                <div>
                                    <p className="modal-titulo"><i className="bi bi-cash-coin"></i> Confirmar recebimento</p>
                                    <p className="modal-subtitulo">
                                        Parcela {recebendo.numero} · {recebendo.Emprestimo?.Empresa?.nomeFantasia || recebendo.Emprestimo?.Empresa?.razaoSocial}
                                    </p>
                                </div>
                                <button type="button" className="modal-fechar" onClick={fecharRecebimento} aria-label="Fechar">×</button>
                            </div>

                            <div className="modal-valor">
                                <span>Valor da parcela</span>
                                <strong className="valor-dinheiro">{real(recebendo.valor)}</strong>
                            </div>

                            <div className="modal-corpo">
                                <div className="campo-form">
                                    <label className="form-label">Valor recebido</label>
                                    <input className="form-control" type="number" step="0.01" inputMode="decimal" autoFocus
                                        value={pagamento.valorPago || ""}
                                        onChange={(e) => setPagamento({...pagamento, valorPago: e.target.value})} required/>
                                </div>
                                <div className="campo-form">
                                    <label className="form-label">Data do pagamento</label>
                                    <input className="form-control" type="date" value={pagamento.dataPagamento || ""}
                                        onChange={(e) => setPagamento({...pagamento, dataPagamento: e.target.value})} required/>
                                </div>
                                <div className="campo-form">
                                    <label className="form-label">Forma de pagamento</label>
                                    <select className="form-select" value={pagamento.formaPagamento || "pix"}
                                        onChange={(e) => setPagamento({...pagamento, formaPagamento: e.target.value})}>
                                        <option value="pix">PIX</option>
                                        <option value="dinheiro">Dinheiro</option>
                                        <option value="transferencia">Transferência</option>
                                        <option value="boleto">Boleto</option>
                                        <option value="cartao">Cartão</option>
                                        <option value="outro">Outro</option>
                                    </select>
                                </div>
                            </div>

                            {(() => {
                                const recebido = Number(pagamento.valorPago);
                                const temValor = !isNaN(recebido) && recebido > 0;
                                const faltou = temValor ? Math.round((recebendo.valor - recebido) * 100) / 100 : 0;
                                if (temValor && faltou > 0.005) {
                                    return (
                                        <>
                                            <div className="modal-aviso-parcial">
                                                <i className="bi bi-exclamation-triangle-fill"></i> Faltam <strong>{real(faltou)}</strong> pra completar a parcela. O que você quer fazer?
                                            </div>
                                            <div className="modal-acoes">
                                                <button type="button" className="btn btn-he" disabled={salvandoBaixa} onClick={() => handleReceber(true)}>
                                                    {salvandoBaixa ? <span className="spinner-border spinner-border-sm"></span> : <><i className="bi bi-bookmark-check"></i> Receber {real(recebido)} e deixar {real(faltou)} em aberto</>}
                                                </button>
                                                <button type="button" className="btn btn-outline-he" disabled={salvandoBaixa} onClick={() => handleReceber(false)}>
                                                    Quitar assim mesmo (desconto de {real(faltou)})
                                                </button>
                                                <button type="button" className="btn btn-texto-suave" onClick={fecharRecebimento}>Cancelar</button>
                                            </div>
                                        </>
                                    );
                                }
                                return (
                                    <div className="modal-acoes">
                                        <button type="submit" className="btn btn-he" disabled={salvandoBaixa}>
                                            {salvandoBaixa ? <span className="spinner-border spinner-border-sm"></span> : <><i className="bi bi-check-lg"></i> Confirmar recebimento</>}
                                        </button>
                                        <button type="button" className="btn btn-outline-he" onClick={fecharRecebimento}>Cancelar</button>
                                    </div>
                                );
                            })()}
                        </form>
                    </div>
                }
                {parcelas.length === 0 ?
                    <Vazio icone="bi bi-check-circle-fill" tom="verde" titulo="Nenhuma parcela nesse filtro"
                           texto={filtro === "atrasadas" ? "Nada atrasado por aqui. Carteira em dia!" : "Quando houver parcela em aberto, ela aparece nesta lista."}/>
                    :
                <div className="tabela-rolavel rolagem-so-desktop">
                <table className="table table-striped table-hover tabela-responsiva">
                    <thead>
                        <tr><th>Empresa</th><th>Contrato</th><th>Parcela</th><th>Vencimento</th><th>Valor</th><th style={{width: "20%"}}>Ações</th></tr>
                    </thead>
                    <tbody>
                        {parcelas.map((p) => {
                            const empresa = p.Emprestimo?.Empresa || {};
                            const atrasada = p.dataVencimento < hoje;
                            return (
                                <tr key={p.id}>
                                    <td className="principal" data-rotulo="Empresa" style={{fontWeight: 600}}>{empresa.nomeFantasia || empresa.razaoSocial}</td>
                                    <td data-rotulo="Contrato"><Link to={`/emprestimo/${p.EmprestimoId}`} style={{color: "#e8c95c"}}>#{p.EmprestimoId}</Link></td>
                                    <td data-rotulo="Parcela">{p.numero}</td>
                                    <td data-rotulo="Vencimento" style={{color: atrasada ? "#ff6b5b" : undefined, fontWeight: atrasada ? 700 : 400}}>
                                        {dataBR(p.dataVencimento)} {atrasada && <span className="badge badge-atrasada">atrasada</span>}
                                    </td>
                                    <td className="destaque valor-dinheiro" data-rotulo="Valor">{real(p.valor)}</td>
                                    <td className="acoes">
                                        <div className="acoes-linha uma-coluna">
                                            <button className="btn btn-sm btn-he" onClick={() => { setRecebendo(p); setPagamento({ valorPago: p.valor, dataPagamento: hoje, formaPagamento: "pix" }); }}>
                                                <i className="bi bi-cash"></i> Receber
                                            </button>
                                            <a className="btn btn-sm btn-success" title="Cobrar no WhatsApp" target="_blank" rel="noreferrer" href={linkWhatsApp(empresa.telefone, mensagemCobranca(p))}>
                                                <i className="bi bi-whatsapp"></i> <span className="so-mobile-inline">Cobrar no WhatsApp</span>
                                            </a>
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                </div>
                }
            </div>}
        </div>
    )
}
